<script>
import iIntake from './_intake.js';

export default {
    name: 'intake',

    mixins: [iIntake],

    data() {
        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);
        let token = params.get("permalink_token");
        let return_url = params.get("return_url");
        let intake_type_id = params.get("intake_type_id");
        let loading = true;

        if (!token) loading = false;

        return {
            home_url: home_url,
            token: token,
            return_url: return_url,
            intake_type_id: intake_type_id,
            intake: null,
            isLoading: loading,
        }
    },

    template: `
    <div class="dash-public-plugin-container dash-public-plugin-intake" v-bind:class="{'is-loading': isLoading}">
        <div v-if="!token || !intake || token && !intake" class="intake-notice">
          <div v-if="!token">No token provided.</div>
          <div v-if="!intake">No intake found.</div>
          <div v-if="token && !intake">No intake found.</div>
        </div>  

        <div v-if="token && intake">
            <div v-if="intake" class="intake-heading">
                <h2 v-if="intake.display_name">{{ intake.display_name }}</h2>
                <h2 v-else>{{ intake.title }}</h2>
                <div v-if="intake.close_date" class="intake-close-date">Close Date: {{ intake.close_date | formatDate }}</div>
            </div>

            <div v-if="intake.event" class="intake-event-details">
                <div class="intake-event-details-heading">Event Details</div>

                <table>
                    <tr if="intake.event.start_date">
                        <th>Start Date</th>
                        <td>{{ intake.event.start_date | formatDate }}</td>
                    </tr>
                    <tr v-if="intake.event.location">
                        <th>Location</th>
                        <td v-html="intake.event.location"></td>
                    </tr>
                </table>
            </div>

            <div class="intake-application">
                <div v-if="intake.is_accepted_interop_region" class="intake-application-heading">Create application</div>

                <div v-if="intake.is_accepted_interop_region" class="intake-application-info">
                    <p v-if="intake.applier_type_id == 'school' || intake.applier_type_id == 'child'">Please use one of the below buttons to start the application process. Please ensure you select the platform that is most relevant to your {{intake.applier_type_id}}.</p>
                    <p v-else>Please use one of the below buttons to start the application process. Please ensure you select the platform that is most relevant to yourself.</p>
                </div>

                <div v-if="intake && return_url && intake_type_id == 'open'" class="intake-buttons">
                    <a v-if="intake.is_accepted_interop_region" :href="'https://nswschoolsportunit.dashapp.com.au'+ return_url">Government<br />Schools (SSU) NSW <i class="far fa-chevron-right"></i></a>
                    <a v-if="intake.is_accepted_interop_region" :href="'https://csnswsport.dashapp.com.au'+ return_url">Catholic<br />Schools (CS) NSW <i class="far fa-chevron-right"></i></a>
                    <a v-if="intake.is_accepted_interop_region" :href="'https://cisnsw.dashapp.com.au'+ return_url">Combined Independent<br />Schools (CIS) NSW Schools <i class="far fa-chevron-right"></i></a>
                    <a v-if="!intake.is_accepted_interop_region" :href="'https://nswschoolsportunit.dashapp.com.au'+ return_url">Start Application Process <i class="far fa-chevron-right"></i></a>
                </div>
            </div>
        </div>
    </div>
  `,

    mounted() {
        const $this = this;

        this.getIntakes();
    },

    methods: {
        getIntakes: function () {
            const $this = this;

            $this.getIntake($this.token, function (intake) {
                $this.intake = intake;

                $this.isLoading = false;
            })
        },
    },
}
</script>